import React from 'react';
import { CheckIcon } from 'lucide-react';
import { differenceOneThings, youKnowItems } from '../data/content';
export function DifferenceSection() {
  return <section className="w-full bg-white px-5 py-12 sm:py-16" data-id="element-31" data-mp="1b41whyplm90j">
      <div className="mx-auto max-w-[960px]" data-id="element-32" data-mp="1p2jjtvbldjhx">
        <h2 className="text-balance text-center text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[2rem]" data-id="element-33" data-mp="1k2ne9rn8xk09">
          What Makes HEALTH READY™ Different?
        </h2>

        <div className="mt-9 grid gap-10 md:grid-cols-2 md:gap-12" data-id="element-34" data-mp="1u135rvq6qvaa">
          <div data-id="element-35" data-mp="1tyqrbsjmz31z">
            <p className="text-[1.05rem] leading-relaxed text-slate-950" data-id="element-36" data-mp="1tz0ez9h7ky4i">
              Most Health Education resources give you
            </p>
            <ul className="mt-2 space-y-1" data-id="element-37" data-mp="22u6hnzl6n02t">
              {differenceOneThings.map(line => <li key={line} className="text-[1.05rem] text-slate-700 line-through decoration-slate-400" data-id="element-38" data-mp="2hrgzdqof526z">
                  {line}
                </li>)}
            </ul>
            <p className="mt-5 text-[1.05rem] leading-relaxed text-slate-950" data-id="element-39" data-mp="2ftqm6wd1et44">
              <strong className="font-extrabold" data-id="element-40" data-mp="2kra88ifz8a6m">HEALTH READY™</strong>{' '}
              is built differently.
            </p>
            <p className="mt-2 text-[1.3rem] font-extrabold uppercase leading-tight tracking-tight text-orange-700 sm:text-[1.5rem]" data-id="element-41" data-mp="2ouordhz7p6oa">
              It gives you an entire teaching SYSTEM.
            </p>
          </div>

          <div className="rounded-lg bg-slate-100 p-6" data-id="element-42" data-mp="33pcuiph53t0q">
            <p className="text-[0.95rem] font-bold text-slate-950" data-id="element-43" data-mp="33nryswj3a41a">You know:</p>
            <ul className="mt-3 space-y-2" data-id="element-44" data-mp="38hmezpzhk0vm">
              {youKnowItems.map(item => <li key={item} className="flex gap-2.5 text-[1rem] text-slate-950" data-id="element-45" data-mp="3cgv8quuizyr6">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-orange-700" strokeWidth={3} aria-hidden="true" data-id="element-46" data-mp="3hewrfeo1hw24" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-[640px] border-t border-slate-200 pt-6 text-center" data-id="element-47" data-mp="1hcouxntxuxe7">
          <p className="text-[1rem] font-bold text-slate-700" data-id="element-48" data-mp="1w5r061qfmdbh">
            The goal is simple:
          </p>
          <p className="mt-2 text-balance text-[1.15rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950 sm:text-[1.3rem]" data-id="element-49" data-mp="1rb4jpk5htukj">
            Help you walk into every Health class with a plan
            already prepared.
          </p>
        </div>
      </div>
    </section>;
}